import React, { useState } from "react";
import { Link, Paper, styled } from "@mui/material";
import { useClinicState } from "../../../../clinic/clinicStateContext";
import { ClinicActionButton } from "fe-web-components/clinic/clinicActionButton";
import { safeCopyToClipboard } from "fe-common/utils/safeCopyToClipboard";
import {
  CLINIC_BASE_URL,
  CLINIC_MANAGE_URL,
} from "../../clinicSettings/clinicUrls";
import { InfoBox } from "../../elements/infoBox";

//region [[ Styles ]]

const ClinicLinkView = styled("div")({});
const ShareLinkView = styled(Paper)({
  display: "flex",
  gap: 10,
  alignItems: "center",
  padding: "20px",
});

const LinkArea = styled("div")({
  display: "flex",
  flexFlow: "column",
  alignItems: "start",
  flex: "1 0",
  gap: 10,
  fontSize: 16,
});

const LinkButtons = styled("div")({
  display: "flex",
  flexWrap: "wrap",
  gap: 8,
  marginLeft: "auto",
});

//endregion [[ Styles ]]

//region [[ Props ]]

//endregion [[ Props ]]

//region [[ Functions ]]
export const conversationLink = (nameid: string) =>
  `${CLINIC_BASE_URL}${nameid}`;
//endregion [[ Functions ]]

export const ClinicLink = () => {
  const [copyLabel, setCopyLabel] = useState<string>(null);
  const handlePrint = () => {
    window.open(`${CLINIC_MANAGE_URL}/${clinicId}/invitePrint`);
  };
  const [
    {
      clinicData: { id: clinicId, displayName, name: clinicName },
    },
  ] = useClinicState();
  const link = conversationLink(clinicName || clinicId);

  const onCopyInvitation = () => {
    safeCopyToClipboard(link).then(() => {
      setCopyLabel("Copied link");
      setTimeout(() => {
        setCopyLabel(null);
      }, 1000);
    });
  };

  return (
    <ClinicLinkView>
      <ShareLinkView>
        <LinkArea className={"link-area"}>
          <strong>{displayName || clinicName} clinic link:</strong>
          <Link target="_blank" href={link} className="share-link">
            {link}
          </Link>
        </LinkArea>
        <LinkButtons>
          <ClinicActionButton
            label={copyLabel || "Copy Clinic Link"}
            onClick={onCopyInvitation}
          />
          <ClinicActionButton
            onClick={handlePrint}
            label={"Print"}
            variant={"outlined"}
          />
        </LinkButtons>
      </ShareLinkView>
      <InfoBox style={{ marginTop: 16, paddingLeft: 16 }}>
        The patients will receive a code at the end of the assessment to be
        later identified in the patient dashboard.
      </InfoBox>
    </ClinicLinkView>
  );
};
